const SUPPORTED_EXCHANGES = new Set(['NASDAQ', 'NYSE', 'CBOE']);

export const normalizePeerTicker = (value) => {
    const normalized = String(value ?? '').trim().toUpperCase();
    if (!normalized || /^[-:]+$/.test(normalized)) return '';
    const separator = normalized.indexOf(':');
    if (separator === -1) return normalized;
    const exchange = normalized.slice(0, separator);
    const ticker = normalized.slice(separator + 1).trim();
    if (!ticker) return '';
    return SUPPORTED_EXCHANGES.has(exchange) ? `${exchange}:${ticker}` : ticker;
};

export const parsePeerTickers = (value) => {
    const entered = String(value ?? '').split(/[\s,;|]+/).map(normalizePeerTicker).filter(Boolean);
    return {
        tickers: [...new Set(entered)],
        duplicates: [...new Set(entered.filter((ticker, index) => entered.indexOf(ticker) !== index))],
    };
};
